import { Component, OnInit } from '@angular/core';
import { IRole } from 'app/models/IRole';
import { OrgService } from 'app/services/org.service';
import { RoleService } from 'app/services/role.service';

@Component({
  selector: 'app-rolelist',
  templateUrl: './rolelist.component.html',
  styleUrls: ['./rolelist.component.scss']
})
export class RolelistComponent implements OnInit {

  public roles: IRole[];
  public filterQuery = '';
  constructor(private roleService: RoleService) { }


  ngOnInit() {
    this.roleService.getRoles().subscribe(
      result => {
        this.roles = result;
      }
    )
  }

  setRole(role: IRole) {
    this.roleService.changeRole(role);
    }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/role/rolelist/rolelist.component.ts